import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, XCircle, Award, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function CertificateVerify() {
  const { certId } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/elearning/verify/${certId}`);
        const json = await res.json();
        setData(json);
      } catch (e) { setData({ valid: false, message: 'Network error' }); }
      finally { setLoading(false); }
    })();
  }, [certId]);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center px-4">
      <div className="w-full max-w-lg">
        <Button variant="ghost" size="sm" onClick={() => navigate('/')} className="mb-4 text-amber-300 hover:bg-amber-500/10" data-testid="verify-back-home">
          <ArrowLeft className="w-4 h-4 mr-1" /> Home
        </Button>
        <div className="rounded-2xl p-8 bg-zinc-950 border border-amber-500/20 text-center" data-testid="verify-card">
          {loading ? (
            <p className="text-gray-400">Verifying…</p>
          ) : data?.valid ? (
            <>
              <div className="w-20 h-20 mx-auto rounded-full bg-emerald-500/15 border-2 border-emerald-500/40 flex items-center justify-center mb-5">
                <CheckCircle2 className="w-12 h-12 text-emerald-400" />
              </div>
              <h1 className="text-2xl font-bold">Verified Certificate</h1>
              <p className="text-xs text-gray-500 mt-1 font-mono">{data.certificate.id}</p>
              <div className="mt-6 space-y-2">
                <Award className="w-8 h-8 mx-auto text-amber-300" />
                <p className="text-lg font-bold text-amber-300">{data.certificate.user_name}</p>
                <p className="text-sm text-gray-300">has successfully completed</p>
                <p className="text-base font-bold">{data.certificate.part_title}</p>
                <p className="text-xs text-gray-500">Issued on {data.certificate.issued_at?.slice(0, 10)}</p>
              </div>
              <div className="mt-6 pt-4 border-t border-zinc-800 text-[10px] text-gray-500 uppercase tracking-[3px]">
                FORTHEWISEPRO LLC · Trading Mastery Program
              </div>
            </>
          ) : (
            <>
              <div className="w-20 h-20 mx-auto rounded-full bg-rose-500/15 border-2 border-rose-500/40 flex items-center justify-center mb-5">
                <XCircle className="w-12 h-12 text-rose-400" />
              </div>
              <h1 className="text-2xl font-bold">Certificate Not Valid</h1>
              <p className="text-sm text-gray-400 mt-2">{data?.message || 'No certificate matches this ID.'}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
